<template>
    <v-app :class="{'offline':!connected}">
        <component :is="layout">
            <router-view />
        </component>
        <Notifications />
    </v-app>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import Notifications from '@/components/SysNotifications';

    export default {
        name: "App",

        components: {
            Notifications,
        },

        data: () => ({}),

        computed: {
            ...mapGetters("appshell", ["dark", "connected", "loading"]),
            ...mapGetters("auth", ["partner"]),

            layout() {
                return (this.$route.meta && this.$route.meta.layout) || "default-layout";
            }
        },
        watch: {
            dark(enabled) {
                this.$vuetify.theme.dark = enabled;
            },
            partner(v) {
                this.setPartnerTheme(v);
            }
        },
        methods: {
            _setAuth0Client() {
                // init Auth0 Client on store:

                this.$store.dispatch("auth/init", {
                    logo: "https://parked.blob.core.windows.net/ownli/www/logos/logo.png",
                    color: this.$vuetify.theme.themes.dark.primary
                });

            },

            _setDynamicManifest() {
                var slug = "mng";
                const base_url = "https://parked.blob.core.windows.net/ownli/www";
                // const manifestURL = "https://parked.blob.core.windows.net/web/" + slug + '/manifest.json';
                // const fabiconURL = "https://parked.blob.core.windows.net/web/" + slug + '/icons/favicon.ico';
                // const fabicon32URL = "https://parked.blob.core.windows.net/web/" + slug + '/icons/favicon-32x32.png';
                // const fabicon16URL = "https://parked.blob.core.windows.net/web/" + slug + '/icons/favicon-16x16.png';
                // const appleIconURL = "https://parked.blob.core.windows.net/web/" + slug +
                //     '/icons/apple-icon-144x144.png';
                const manifestURL = `${base_url}/manifest.json`;
                const fabiconURL = `${base_url}/icons/favicon.ico`;
                const fabicon32URL = `${base_url}/icons/32.png`;
                const fabicon16URL = `${base_url}/icons/16.png`;
                const appleIconURL = `${base_url}/icons/144.png`;
                document.querySelector('link[rel="manifest"]').setAttribute('href', manifestURL);

                document.querySelector('meta[name="theme-color"]').setAttribute('content', this.$vuetify.theme.themes
                    .dark.primary);
                document.querySelector('meta[name="msapplication-TileImage"]').setAttribute('content', appleIconURL);

                document.querySelector('link[rel="icon"]').setAttribute('href', fabiconURL);
                document.querySelector('link[rel="icon"][sizes="32x32"]').setAttribute('href', fabicon32URL);
                document.querySelector('link[rel="icon"][sizes="16x16"]').setAttribute('href', fabicon16URL);
                document.querySelector('link[rel="apple-touch-icon"]').setAttribute('href', appleIconURL);
            },

            setPartnerTheme(v) {
                const theme = v.theme;
                // Light theme
                this.$vuetify.theme.themes.light.primary = theme.primary;
                this.$vuetify.theme.themes.light.secondary = theme.secondary;
                this.$vuetify.theme.themes.light.accent = theme.accent;
                // Dark theme
                this.$vuetify.theme.themes.dark.primary = theme.primary;
                this.$vuetify.theme.themes.dark.secondary = theme.secondary;
                this.$vuetify.theme.themes.dark.accent = theme.accent;
            },
        },

        async created() {
            this.$vuetify.theme.dark = this.dark;
            this._setAuth0Client();
            this._setDynamicManifest();
        },

        mounted() {
            if (this.partner) {
                this.setPartnerTheme(this.partner);
            }
        }
    };
</script>

<style lang="scss">
    @import "assets/app.scss";

    #app.offline {
        filter: grayscale(0.8);
    }

    @media print {
        #header {
            display: none;
        }

        #drawer {
            display: none;
        }

        .v-content {
            width: 100% !important;
            padding: 20px !important;
        }
    }
</style>